import { View } from 'components/View'
import PropTypes from 'prop-types'
import React from 'react'

class HeaderActions extends React.Component {
  render () {
    const children = React.Children
      .toArray(this.props.children)
      .filter(child => child)
    return (
      <View
        style={{
          marginLeft: 'auto',
          flexDirection: View.DIRECTION.ROW,
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {children}
      </View>
    )
  }
}

HeaderActions.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.element
  ).isRequired
}
export default HeaderActions
